import React, { FC, useState } from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { NavDropdownMenu } from "react-bootstrap-submenu";
import { useDispatch } from "react-redux";
import { startApplyRule } from "../../../../actions/ruleAction";
import { ActionModel } from "../../../../models/actionModel";
import { NavigationTabs } from "../../../../models/NavigationTabsModel";
import NavigationDropdown from "./NavigationDropdown";

export interface NavTabsProps {
  index: string;
  element: NavigationTabs[];
  actions: ActionModel[];
}
const NavTabs: FC<NavTabsProps> = ({ index, element, actions }) => {
  const dispatch = useDispatch();
  const [onClickActions, setOnClickActions] = useState(
    actions.filter((action) => {
      return action.actionType === "onClick";
    })
  );

  async function OnClickActions(tabId: String) {
    await Promise.all(
      onClickActions
        .map(async (action) => {
          if(action.navTabValue == tabId){
              dispatch(startApplyRule(action));
          }
        })
    );
  }
  const RightTabsRender = element
    .filter((tabEl) => tabEl.align == "mr-auto")
    .map((tab) => {
      //custome css - start
      const styleList = tab.cssStyles;

      const styleObj: { [key: string]: any } = {};

      for (let index = 0; index < styleList.length; index++) {
        styleObj[styleList[index].retrivedStyle] = styleList[index].value;
      }
      //custome css - end
      return tab.isDropdown ? (
        <NavDropdownMenu
          title={tab.name.toString()}
          id={tab.id.toString()}
          alignRight={tab.alignRight}
        >
          <NavigationDropdown index={index} element={tab.dropdown} actions={actions}/>
        </NavDropdownMenu>
      ) : (
        <Nav.Link
          style={{ ...styleObj }}
          id={tab.id.toString()}
          onClick={() => {
            OnClickActions(tab.id);
          }}
        >
          {tab.name}
        </Nav.Link>
      );
    });
  const LeftTabsRender = element
    .filter((tabEl) => tabEl.align == "ml-auto")
    .map((tab) => {
      //custome css - start
      const styleListLeft = tab.cssStyles;

      const styleObjLeft: { [key: string]: any } = {};

      for (let index = 0; index < styleListLeft.length; index++) {
        styleObjLeft[styleListLeft[index].retrivedStyle] =
          styleListLeft[index].value;
      }
      //custome css - end
      return tab.isDropdown ? (
        <NavDropdownMenu
          title={tab.name.toString()}
          id={tab.id.toString()}
          alignRight={tab.alignRight}
        >
          <NavigationDropdown index={index} element={tab.dropdown} actions={actions}/>
        </NavDropdownMenu>
      ) : (
        <Nav.Link style={{ ...styleObjLeft }} id={tab.id.toString()}>
          {tab.name}
        </Nav.Link>
      );
    });

  return (
    <>
      <Nav className="mr-auto">{RightTabsRender}</Nav>
      <Nav className="ml-auto">{LeftTabsRender}</Nav>
    </>
  );
};

export default NavTabs;
